/**
 * Feature Flags Configuration
 *
 * Toggle between old custom components and new library-based components.
 * Set to false to rollback to original implementations.
 */

export const features = {
  // Use react-big-calendar instead of custom CalendarGrid
  useBigCalendar: true,

  // Use Monaco Editor + Mermaid instead of custom DiagramBlock
  useMonacoDiagram: true,

  // Use SVAR Gantt for timeline view (new feature, no fallback)
  useSvarGantt: true,
};

export default features;
